import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { makeValidateRegex, validateGithubRepository } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Devin",
  category: AgentCategory.CODING,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#47C19A",
  description: "Hand off entire engineering tasks to an autonomous AI that plans, codes, tests, and debugs on its own",
  descriptionMarkdown: `## Overview

Delegate coding work to Devin, Cognition's AI software engineer. Dart starts a Devin session from your task, links you back to the live session, and completes the Dart task when Devin finishes or opens a pull request.

Dart uses Devin's current organization API, which requires a service user API key with session permissions and a Devin organization ID.

## Setup guide

1. In Devin, [create a service user](https://app.devin.ai/settings/org-service-users) API key with member organization role
2. Copy your Devin organization ID from [service user settings](https://app.devin.ai/settings/org-service-users)
3. Make sure the GitHub repository is available to Devin
4. Open Dart settings, go to Agents, and choose Devin
5. Paste your API key, organization ID, and GitHub repo (accepted formats: \`owner/repo\`, \`https://github.com/owner/repo\`, or \`git@github.com:owner/repo.git\`)
6. Assign coding tasks to Devin from Dart`,
  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "Devin API key",
      placeholder: "Your Devin service user API key",
      validate: makeValidateRegex(/^cog_[A-Za-z0-9_-]+$/, "Enter a valid Devin service user API key", true),
    },
    {
      key: "orgId",
      type: "text",
      label: "Organization ID",
      placeholder: "org-abc123def456",
      validate: makeValidateRegex(/^org-[A-Za-z0-9_-]+$/, "Enter a valid Devin organization ID", true),
    },
    {
      key: "repository",
      type: "text",
      label: "GitHub repo",
      placeholder: "owner/repository",
      validate: validateGithubRepository,
    },
  ],
};

export default config;
